import { render } from "./CategoryHeader.vue?vue&type=template&id=5d5b530e"
import script from "./CategoryHeader.vue?vue&type=script&lang=js"
export * from "./CategoryHeader.vue?vue&type=script&lang=js"

import "./CategoryHeader.vue?vue&type=style&index=0&id=5d5b530e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__